import Bookmarks from "../Pages/Applications/Bookmarks";
import Calendar from "../Pages/Applications/Calendar";
import GroupChat from "../Pages/Applications/Chat/GroupChat";
import PrivateChat from "../Pages/Applications/Chat/PrivateChat";
import Contacts from "../Pages/Applications/Contacts";
import AddProducts from "../Pages/Applications/ECommerce/AddProducts";
import Cart from "../Pages/Applications/ECommerce/Cart";
import CategoryPage from "../Pages/Applications/ECommerce/CategoryPage";
import CheckOut from "../Pages/Applications/ECommerce/CheckOut";
import Invoice6 from "../Pages/Applications/ECommerce/Invoice/Invoice6";
import OrderHistory from "../Pages/Applications/ECommerce/OrderHistory";
import PaymentDetails from "../Pages/Applications/ECommerce/PaymentDetails";
import Pricing from "../Pages/Applications/ECommerce/Pricing";
import Product from "../Pages/Applications/ECommerce/Product";
import ProductList from "../Pages/Applications/ECommerce/ProductList/inedx";
import ProductPage from "../Pages/Applications/ECommerce/ProductPage";
import Wishlist from "../Pages/Applications/ECommerce/WishList";
import FileManager from "../Pages/Applications/FileManager";
import LetterBox from "../Pages/Applications/LetterBox";
import CreateNew from "../Pages/Applications/Project/CreateNew";
import ProjectList from "../Pages/Applications/Project/ProjectList";
import SearchResult from "../Pages/Applications/SearchResult";
import SocialApp from "../Pages/Applications/SocialApp";
import Task from "../Pages/Applications/Task";
import Todo from "../Pages/Applications/ToDo";
import EditProfile from "../Pages/Applications/Users/EditProfile";
import UsersCards from "../Pages/Applications/Users/UsersCards";
import UsersProfile from "../Pages/Applications/Users/UsersProfile";
import BasicCard from "../Pages/BonusUi/BasicCard";
import Breadcrumb from "../Pages/BonusUi/Breadcrumb";
import CreativeCard from "../Pages/BonusUi/CreativeCard";
import Dropzone from "../Pages/BonusUi/Dropzone";
import ImageCropper from "../Pages/BonusUi/ImageCropper";
import Pagination from "../Pages/BonusUi/Pagination";
import RangeSlider from "../Pages/BonusUi/RangeSlider";
import Rating from "../Pages/BonusUi/Rating";
import Carousel from "../Pages/BonusUi/Carousel";
import Ribbons from "../Pages/BonusUi/Ribbons";
import Scrollable from "../Pages/BonusUi/Scrollable";
import SweetAlert from "../Pages/BonusUi/SweetAlert";
import TimeLine from "../Pages/BonusUi/TimeLine";
import Toasts from "../Pages/BonusUi/Toasts";
import Tour from "../Pages/BonusUi/Tour";
import Tree from "../Pages/BonusUi/Tree";
import ButtonGroup from "../Pages/Button/ButtonGroup";
import DefaultStyle from "../Pages/Button/DefaultStyle";
import ApexChart from "../Pages/Charts/ApexChart";
import ChartJs from "../Pages/Charts/ChartJs";
import GoogleChart from "../Pages/Charts/GoogleChart";
import BaseInput from "../Pages/Forms&Table/Forms/FormControls/BaseInput";
import CheckBoxAndRadio from "../Pages/Forms&Table/Forms/FormControls/CheckboxAndRadio";
import FormValidation from "../Pages/Forms&Table/Forms/FormControls/FormValidation";
import InputGroup from "../Pages/Forms&Table/Forms/FormControls/InputGroup";
import InputMark from "../Pages/Forms&Table/Forms/FormControls/InputMark";
import MegaOptions from "../Pages/Forms&Table/Forms/FormControls/MegaOptions";
import FormWizard1 from "../Pages/Forms&Table/Forms/FormLayout/FormWizard1";
import FormWizard2 from "../Pages/Forms&Table/Forms/FormLayout/FormWizard2";
import TwoFactor from "../Pages/Forms&Table/Forms/FormLayout/Twofactor";
import Clipboard from "../Pages/Forms&Table/Forms/FormWidgets/Clipboard";
import DatePicker from "../Pages/Forms&Table/Forms/FormWidgets/DatePicker";
import Switch from "../Pages/Forms&Table/Forms/FormWidgets/Switch";
import Touchspin from "../Pages/Forms&Table/Forms/FormWidgets/Touchspin";
import Typeahead from "../Pages/Forms&Table/Forms/FormWidgets/Typeahead";
import AdvanceInit from "../Pages/Forms&Table/Tables/DataTables/AdvanceInit";
import Api from "../Pages/Forms&Table/Tables/DataTables/Api";
import BasicInit from "../Pages/Forms&Table/Tables/DataTables/BasicInit";
import DataSources from "../Pages/Forms&Table/Tables/DataTables/DataSources";
import BasicTables from "../Pages/Forms&Table/Tables/ReactstrapTables/BasicTables";
import TableComponents from "../Pages/Forms&Table/Tables/ReactstrapTables/TableComponents";
import Default from "../Pages/General/Dashboard/Default/index";
import ECommerce from "../Pages/General/Dashboard/ECommerce";
import Chart from "../Pages/General/Widgets/Chart";
import General from "../Pages/General/Widgets/General";
import FeatherIcon from "../Pages/Icon/FeatherIcon";
import FlagIcon from "../Pages/Icon/FlagIcon";
import FontAwesome from "../Pages/Icon/FontAwesome";
import IcoIcon from "../Pages/Icon/IcoIcon";
import ThemifyIcon from "../Pages/Icon/ThemifyIcon";
import WetherIcon from "../Pages/Icon/WetherIcon";
import AddPost from "../Pages/Miscellaneous/Blog/AddPost";
import BlogDetails from "../Pages/Miscellaneous/Blog/BlogDetails";
import BlogGrids from "../Pages/Miscellaneous/Blog/BlogGrids";
import AceCodeEditor from "../Pages/Miscellaneous/Editors/AceCodeEditor";
import QuillEditor from "../Pages/Miscellaneous/Editors/QuillEditor";
import FAQ from "../Pages/Miscellaneous/FAQ";
import GalleryDescription from "../Pages/Miscellaneous/Gallery/GalleryDescription";
import GalleryGrid from "../Pages/Miscellaneous/Gallery/GalleryGrid";
import GalleryHover from "../Pages/Miscellaneous/Gallery/GalleryHover";
import MasonryDescription from "../Pages/Miscellaneous/Gallery/MasonryDescription";
import MasonryGallery from "../Pages/Miscellaneous/Gallery/MasonryGallery";
import CardsView from "../Pages/Miscellaneous/JobSearch/CardsView";
import JobApply from "../Pages/Miscellaneous/JobSearch/JobApply";
import JobDetails from "../Pages/Miscellaneous/JobSearch/JobDetails";
import ListView from "../Pages/Miscellaneous/JobSearch/ListView";
import Knowledgebase from "../Pages/Miscellaneous/Knowledgebase";
import CourseDetails from "../Pages/Miscellaneous/Learning/CourseDetails";
import LearningList from "../Pages/Miscellaneous/Learning/LearningList";
import GoogleMap from "../Pages/Miscellaneous/Maps/GoogleMap";
import LeafletMap from "../Pages/Miscellaneous/Maps/LeafletMap";
import SupportTicket from "../Pages/Miscellaneous/SupportTicket";
import SamplePage from "../Pages/Pages/SamplePage";
import Accordion from "../Pages/UiKits/Accordion";
import Alert from "../Pages/UiKits/Alert";
import Avatars from "../Pages/UiKits/Avatars";
import Dropdown from "../Pages/UiKits/Dropdown";
import Grid from "../Pages/UiKits/Grid";
import HelperClasses from "../Pages/UiKits/HelperClasses";
import Lists from "../Pages/UiKits/Lists";
import Modal from "../Pages/UiKits/Modal";
import Popover from "../Pages/UiKits/Popover";
import ProgressBar from "../Pages/UiKits/ProgressBar";
import Tabs from "../Pages/UiKits/Tabs";
import TagAndPills from "../Pages/UiKits/Tag&Pills";
import Tooltip from "../Pages/UiKits/Tooltip";
import Typography from "../Pages/UiKits/Typography";

export const routes = [
  //Dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, element: <Default /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`, element: <ECommerce /> },
  //Widget
  { path: `${process.env.PUBLIC_URL}/widgets/general_widget`, element: <General /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart_widget`, element: <Chart /> },
  //Application
  { path: `${process.env.PUBLIC_URL}/applications/project/project_list`, element: <ProjectList /> },
  { path: `${process.env.PUBLIC_URL}/applications/project/create_new`, element: <CreateNew /> },
  { path: `${process.env.PUBLIC_URL}/applications/file_manager`, element: <FileManager /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/add_products`, element: <AddProducts /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/product`, element: <Product /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/category_page`, element: <CategoryPage /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/product_page`, element: <ProductPage /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/product_list`, element: <ProductList /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/payment_details`, element: <PaymentDetails /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/order_history`, element: <OrderHistory /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/cart`, element: <Cart /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/wishlist`, element: <Wishlist /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/checkout`, element: <CheckOut /> },
  { path: `${process.env.PUBLIC_URL}/applications/ecommerce/pricing`, element: <Pricing /> },

  { path: `${process.env.PUBLIC_URL}/invoice/invoice_6`, element: <Invoice6 /> },
  { path: `${process.env.PUBLIC_URL}/applications/email/letter_box`, element: <LetterBox /> },
  { path: `${process.env.PUBLIC_URL}/applications/chat/chat_private`, element: <PrivateChat /> },
  { path: `${process.env.PUBLIC_URL}/applications/chat/chat_group`, element: <GroupChat /> },
  { path: `${process.env.PUBLIC_URL}/applications/users/user_profile`, element: <UsersProfile /> },
  { path: `${process.env.PUBLIC_URL}/applications/users/edit_profile`, element: <EditProfile /> },
  { path: `${process.env.PUBLIC_URL}/applications/users/user_cards`, element: <UsersCards /> },
  { path: `${process.env.PUBLIC_URL}/applications/bookmark`, element: <Bookmarks /> },
  { path: `${process.env.PUBLIC_URL}/applications/contacts`, element: <Contacts /> },
  { path: `${process.env.PUBLIC_URL}/applications/task`, element: <Task /> },
  { path: `${process.env.PUBLIC_URL}/applications/calendar`, element: <Calendar /> },
  { path: `${process.env.PUBLIC_URL}/applications/social_app`, element: <SocialApp /> },
  { path: `${process.env.PUBLIC_URL}/applications/to_do`, element: <Todo /> },
  { path: `${process.env.PUBLIC_URL}/applications/search_result`, element: <SearchResult /> },
  //Forms
  { path: `${process.env.PUBLIC_URL}/forms/form_controls/form_validation`, element: <FormValidation /> },
  { path: `${process.env.PUBLIC_URL}/forms/form_controls/base_input`, element: <BaseInput /> },
  { path: `${process.env.PUBLIC_URL}/forms/form_controls/radio_checkbox_control`, element: <CheckBoxAndRadio /> },
  { path: `${process.env.PUBLIC_URL}/forms/form_controls/input_group`, element: <InputGroup /> },
  { path: `${process.env.PUBLIC_URL}/forms/form_controls/input_mask`, element: <InputMark /> },
  { path: `${process.env.PUBLIC_URL}/forms/form_controls/mega_options`, element: <MegaOptions /> },
  { path: `${process.env.PUBLIC_URL}/forms/form_widgets/datepicker`, element: <DatePicker /> },
  { path: `${process.env.PUBLIC_URL}/forms/form_widgets/touchspin`, element: <Touchspin /> },
  { path: `${process.env.PUBLIC_URL}/forms/form_widgets/switch`, element: <Switch /> },
  { path: `${process.env.PUBLIC_URL}/forms/form_widgets/typeahead`, element: <Typeahead /> },
  { path: `${process.env.PUBLIC_URL}/forms/form_widgets/clipboard`, element: <Clipboard /> },
  { path: `${process.env.PUBLIC_URL}/forms/form_layout/form_wizard_2`, element: <FormWizard2 /> },
  { path: `${process.env.PUBLIC_URL}/forms/form_layout/form_wizard_1`, element: <FormWizard1 /> },
  { path: `${process.env.PUBLIC_URL}/forms/form_layout/two_factor`, element: <TwoFactor /> },
  //Tables
  { path: `${process.env.PUBLIC_URL}/table/reactstrap_tables/basic_table`, element: <BasicTables /> },
  { path: `${process.env.PUBLIC_URL}/table/reactstrap_tables/table_components`, element: <TableComponents /> },
  { path: `${process.env.PUBLIC_URL}/table/data_tables/basic_init`, element: <BasicInit /> },
  { path: `${process.env.PUBLIC_URL}/table/data_tables/advance_init`, element: <AdvanceInit /> },
  { path: `${process.env.PUBLIC_URL}/table/data_tables/api`, element: <Api /> },
  { path: `${process.env.PUBLIC_URL}/table/data_tables/data_sources`, element: <DataSources /> },
  //Component
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/typography`, element: <Typography /> },
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/avatars`, element: <Avatars /> },
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/helper_classes`, element: <HelperClasses /> },
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/grid`, element: <Grid /> },
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/tag_pills`, element: <TagAndPills /> },
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/progress_bar`, element: <ProgressBar /> },
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/modal`, element: <Modal /> },
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/alert`, element: <Alert /> },
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/popover`, element: <Popover /> },
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/tooltip`, element: <Tooltip /> },
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/dropdown`, element: <Dropdown /> },
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/accordion`, element: <Accordion /> },
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/tabs`, element: <Tabs /> },
  { path: `${process.env.PUBLIC_URL}/components/ui_kits/lists`, element: <Lists /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/scrollable`, element: <Scrollable /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/timeline`, element: <TimeLine /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/range_slider`, element: <RangeSlider /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/basic_card`, element: <BasicCard /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/creative_card`, element: <CreativeCard /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/carousel`, element: <Carousel /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/pagination`, element: <Pagination /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/breadcrumb`, element: <Breadcrumb /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/image_cropper`, element: <ImageCropper /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/tour`, element: <Tour /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/sweet_alert_2`, element: <SweetAlert /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/ribbons`, element: <Ribbons /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/toasts`, element: <Toasts /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/rating`, element: <Rating /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/dropzone`, element: <Dropzone /> },
  { path: `${process.env.PUBLIC_URL}/components/bonus_ui/tree`, element: <Tree /> },
  { path: `${process.env.PUBLIC_URL}/components/icons/flag_icon`, element: <FlagIcon /> },
  { path: `${process.env.PUBLIC_URL}/components/icons/font_awesome`, element: <FontAwesome /> },
  { path: `${process.env.PUBLIC_URL}/components/icons/ico_icon`, element: <IcoIcon /> },
  { path: `${process.env.PUBLIC_URL}/components/icons/themify_icon`, element: <ThemifyIcon /> },
  { path: `${process.env.PUBLIC_URL}/components/icons/feather_icon`, element: <FeatherIcon /> },
  { path: `${process.env.PUBLIC_URL}/components/icons/whether_icon`, element: <WetherIcon /> },
  { path: `${process.env.PUBLIC_URL}/components/button/default_style`, element: <DefaultStyle /> },
  { path: `${process.env.PUBLIC_URL}/components/button/button_group`, element: <ButtonGroup /> },
  { path: `${process.env.PUBLIC_URL}/components/charts/chart_google`, element: <GoogleChart /> },
  { path: `${process.env.PUBLIC_URL}/components/charts/chartjs`, element: <ChartJs /> },
  { path: `${process.env.PUBLIC_URL}/components/charts/chart_apex`, element: <ApexChart /> },
  //Page
  { path: `${process.env.PUBLIC_URL}/pages/sample_page`, element: <SamplePage /> },
  //Miscellaneous
  { path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/grid_gallery`, element: <GalleryGrid /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/grid_gallery_description`, element: <GalleryDescription /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/masonry_gallery`, element: <MasonryGallery /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/masonry_gallery_description`, element: <MasonryDescription /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/gallery/gallery_hover`, element: <GalleryHover /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/blog/blog_grids`, element: <BlogGrids /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/blog/blog_details`, element: <BlogDetails /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/blog/add_post`, element: <AddPost /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/faq`, element: <FAQ /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/job_search/job_cards_view`, element: <CardsView /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/job_search/job_list_view`, element: <ListView /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/job_search/job_details`, element: <JobDetails /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/job_search/job_apply`, element: <JobApply /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/learning/learning_list_view`, element: <LearningList /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/learning/course_details`, element: <CourseDetails /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/maps/google_map`, element: <GoogleMap /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/maps/leaflet_map`, element: <LeafletMap /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/editors/quill_editor`, element: <QuillEditor /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/editors/ace_code_editor`, element: <AceCodeEditor /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/knowledgebase`, element: <Knowledgebase /> },
  { path: `${process.env.PUBLIC_URL}/miscellaneous/support_ticket`, element: <SupportTicket /> },
];
